var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnnual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16.875H21.5625C20.0092 16.875 18.75 18.1342 18.75 19.6875C18.75 21.2408 20.0092 22.5 21.5625 22.5H23.4375C24.9908 22.5 26.25 23.7592 26.25 25.3125C26.25 26.8658 24.9908 28.125 23.4375 28.125H18.75M22.5 15V16.875M22.5 28.125V30M33.75 22.5H33.7688M11.25 22.5H11.2688M3.75 15.375L3.75 29.625C3.75 31.7252 3.75 32.7753 4.15873 33.5775C4.51825 34.2831 5.09193 34.8567 5.79754 35.2163C6.5997 35.625 7.6498 35.625 9.75 35.625L35.25 35.625C37.3502 35.625 38.4003 35.625 39.2025 35.2163C39.9081 34.8567 40.4817 34.2831 40.8413 33.5775C41.25 32.7753 41.25 31.7252 41.25 29.625V15.375C41.25 13.2748 41.25 12.2247 40.8413 11.4225C40.4818 10.7169 39.9081 10.1433 39.2025 9.78373C38.4003 9.375 37.3502 9.375 35.25 9.375L9.75 9.375C7.6498 9.375 6.59971 9.375 5.79754 9.78373C5.09193 10.1433 4.51825 10.7169 4.15873 11.4225C3.75 12.2247 3.75 13.2748 3.75 15.375ZM34.6875 22.5C34.6875 23.0178 34.2678 23.4375 33.75 23.4375C33.2322 23.4375 32.8125 23.0178 32.8125 22.5C32.8125 21.9822 33.2322 21.5625 33.75 21.5625C34.2678 21.5625 34.6875 21.9822 34.6875 22.5ZM12.1875 22.5C12.1875 23.0178 11.7678 23.4375 11.25 23.4375C10.7322 23.4375 10.3125 23.0178 10.3125 22.5C10.3125 21.9822 10.7322 21.5625 11.25 21.5625C11.7678 21.5625 12.1875 21.9822 12.1875 22.5Z",
    stroke: "#383ECB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnual);
export default __webpack_public_path__ + "static/media/icon-annual.7b0efe65b51fe6f1cd0f352f2f5dbec0.svg";
export { ForwardRef as ReactComponent };